import { useNavigate } from 'react-router-dom'

import { getNextStep, SESSIONS_STEPS_LIST } from './sessionsLib'

const useSessionStepNavigation = () => {
  const navigate = useNavigate()

  const goToNextStep = async (sessionId, currentStep) => {
    const nextStep = getNextStep(currentStep)
    navigate(`/sessions/${sessionId}/${nextStep}`)
  }

  const goToStep = async (sessionId, stepId) => {
    const step = SESSIONS_STEPS_LIST[stepId]
    navigate(`/sessions/${sessionId}/${step}`)
  }

  return {
    goToNextStep,
    goToStep,
  }
}

export default useSessionStepNavigation
